module.exports = __webpack_public_path__ + "img/Puppis.ee111cda.png";